import { createFileRoute, redirect } from '@tanstack/react-router'

// The authenticated landing resolves to the "Today" workspace — a real, bounded
// surface (due/overdue tasks, active pipeline, recently updated accounts) with a
// designed empty state for every widget, so it is useful even for a brand-new
// tenant. Accounts remains one click away in the nav.
export const Route = createFileRoute('/_authed/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' })
  },
})
